module.exports = __webpack_public_path__ + "static/choose-your-role-ec7e28a2890466d7817f4683867f54d2.png";